import React, { useEffect, useState, useRef } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import Card from "@mui/material/Card";
import { Box, styled, useMediaQuery, useTheme } from "@mui/system";
import WarehouseLocationVm from "../viewmodel/WarehouseLocationVm";
import CBackDrop from "../../../basecomp/components/CBackDrop";
import CAccordion from "./CAccordion";
import CAuthPopUpBox from "../../../basecomp/components/CAuthPopUpBox";
import MailIcon from "@mui/icons-material/Mail";
import CloseIcon from "@mui/icons-material/Close";
import materialCountedPostApiCall from "../model/MaterialCountModel";
import CountingConfirmation from "./CountingConfirmation";
import EmailConfirmation from "./EmailConfirmation";
import { useToast } from "../../../basecomp/components/provider/ToastProvider";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import InfoIcon from "@mui/icons-material/Info";

const commonFontSize = ".9em";

const StyledInput = styled("input")(({ c_ohq, value }) => {
  // const isMatch = Number(c_ohq) === Number(value);

  return {
    width: "55px",
    height: "30px",
    padding: "0",
    borderRadius: "4px",
    backgroundColor: "red",
    border: "none",
    color: "white",
    textAlign: "center",
    fontSize: ".9em",
    outline: "none",
    transition: "background-color 0.2s ease",
    // visibility: isMatch ? "hidden" : "visible",
    "&::-webkit-inner-spin-button, &::-webkit-outer-spin-button": {
      WebkitAppearance: "none",
      margin: 0,
    },
    "&[type=number]": {
      MozAppearance: "textfield",
    },

    "&:focus": {
      backgroundColor: "white",
      border: "1px solid red",
      color: "black",
    },
  };
});

const WareHouseCounting = () => {
  const {
    wareHouseAllMaterialData,
    terminal_id,
    storage_loc,
    loading,
    storage_bin,
    popUpBox,
  } = WarehouseLocationVm();
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));
  const { handleToastOpen } = useToast();
  const inputRefs = useRef({});
  const navigate = useNavigate();
  const [assetData, setAssetData] = useState([]);
  const [infoRowData, setInfoRowData] = useState([]);
  const [inventoryStatus, setInventoryStatus] = useState({});
  const [okResults, setOkResults] = useState([]);
  const [nokResults, setNokResults] = useState([]);
  const [isDisabled, setIsDisabled] = useState(true);
  const [sendLoading, setSendLoading] = useState(false);
  const [confirmationBox, setConfirmationBox] = useState(false);
  const [firstClickTimestamp, setFirstClickTimestamp] = useState(null);
  const [isConfirmation, setIsConfirmation] = useState(false);
  const [userType, setUserType] = useState("Warehouse User");
  const [currentValue, setCurrentValue] = useState({})
  const OrderBoxText = styled("div")({
    textAlign: "center",
    backgroundColor: "#3CB043",
    color: "white",
    padding: ".5em",
    borderRadius: "0.7em 0.7em 0em 0em",
    fontSize: isXs ? ".9em" : "1.2em",
  });
  const confirmationBoxOpen = async () => {
    await setIsConfirmation(true);
  };
  const confirmationBoxClose = async () => {
    await setIsConfirmation(false);
  };

  const formatTimestamp = () => {
    try {
      const timeZone = localStorage.getItem("time_zone");
      if (!timeZone || typeof timeZone !== "string" || timeZone.trim() === "") {
        console.warn("Invalid or missing timezone in localStorage");
        return null;
      }
      const date = new Date();
      return new Intl.DateTimeFormat("en-US", {
        timeZone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "numeric",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      })
        .format(date)
        .replace(",", "")
        .replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3-$1-$2");
    } catch (error) {
      console.error("Error formatting timestamp:", error);
      return null;
    }
  };

  useEffect(() => {
    setFirstClickTimestamp(formatTimestamp());
    let inventoryData = JSON.parse(sessionStorage.getItem("inventoryStatus"))
    let ok = JSON.parse(sessionStorage.getItem("okresults"))
    let nok = JSON.parse(sessionStorage.getItem("nokResults"))
    if (inventoryData != null) {
      setInventoryStatus(inventoryData)
    }
    if (nok != null) {
      setNokResults(nok)
    }
    if (ok != null) {
      setOkResults(ok)
    }
  }, []);

  useEffect(() => {
    console.log("inventory status changed");
    console.log(inventoryStatus);
    sessionStorage.setItem("inventoryStatus", JSON.stringify(inventoryStatus))
    sessionStorage.setItem("okresults", JSON.stringify(okResults))
    sessionStorage.setItem("nokResults", JSON.stringify(nokResults))
  }, [inventoryStatus])

  const getFormattedDateTime = () => {
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().slice(0, 10);
    const currentTime = currentDate.toLocaleTimeString();
    return formattedDate + "_" + currentTime;
  };

  const handleCount = async () => {
    confirmationBoxClose();
    setSendLoading(true);
    try {
      if (nokResults && nokResults.length > 0) {
        for (const result of nokResults) {
          const qty = result.updated_qty;

          if (!qty || qty.length === 0 || qty === "") {
            console.log("we are in handel count with qty ", qty, result.updated_qty);
            console.log("printing done");
            handleToastOpen(
              "error",
              "Invalid counted quantity! Please enter a valid number."
            );
            setSendLoading(false);
            return;
          }

          if (qty > 10000) {
            handleToastOpen(
              "error",
              "Invalid counted quantity range. Maximum allowed is 10000."
            );
            setSendLoading(false);
            return;
          }
        }
      }

      const payload = {
        storage_bin,
        storage_loc,
        first_action_timestamp: firstClickTimestamp,
        okresults: okResults.map((result) => ({
          material_no: result.material_no,
          bin_location: result.bin_location,
          b_un: result.b_un,
          abc_class: result.abc_class,
          ohqty: result.ohqty,
          material_desc: result.material_desc,
          updated_qty: null,
          isUpdated: false,
        })),
        nokresults: nokResults.map((result) => ({
          material_no: result.material_no,
          bin_location: result.bin_location,
          b_un: result.b_un,
          abc_class: result.abc_class,
          ohqty: result.ohqty,
          material_desc: result.material_desc,
          updated_qty: Number(result.updated_qty),
          isUpdated: true,
        })),
      };

      const response = await materialCountedPostApiCall(
        "/gsone/materialCounting",
        payload,
      );

      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Material_Counted_List_${getFormattedDateTime()}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      if (response.data) {
        setConfirmationBox(true);
      }
      sessionStorage.removeItem("okresults")
      sessionStorage.removeItem("inventoryStatus")
      sessionStorage.removeItem("nokResults")
    } catch (error) {
      console.error("Error:", error.response?.data || error.message);
    } finally {
      setSendLoading(false);
    }
  };

  const handleOkClick = (
    material_no,
    ohqty,
    bin_location,
    material_desc,
    b_un,
    abc_class,
  ) => {
    // Remove from nokResults if it exists there
    console.log("in material ok click");
    setNokResults((prev) =>
      prev.filter((item) => item.material_no !== material_no),
    );

    setInventoryStatus((prev) => ({
      ...prev,
      [material_no]: {
        ...prev[material_no],
        okClicked: true,
        nokClicked: false,
        validationPassed: true,
      },
    }));

    setOkResults((prev) => {
      const existingIndex = prev.findIndex(
        (item) => item.material_no === material_no,
      );

      const resultItem = {
        material_no,
        ohqty,
        bin_location,
        material_desc,
        b_un,
        abc_class,
      };

      if (existingIndex !== -1) {
        const updatedResults = [...prev];
        updatedResults[existingIndex] = resultItem;
        return updatedResults;
      } else {
        return [...prev, resultItem];
      }
    });
  };

  const handleNokClick = (
    material_no,
    ohqty,
    bin_location,
    material_desc,
    b_un,
    abc_class,
  ) => {
    // Remove from okResults if it exists there
    setOkResults((prev) =>
      prev.filter((item) => item.material_no !== material_no),
    );

    setInventoryStatus((prev) => ({
      ...prev,
      [material_no]: {
        ...prev[material_no],
        nokClicked: true,
        okClicked: true,
        validationPassed: false,
        originalOhqty: ohqty,
      },
    }));

    setNokResults((prev) => {
      const existingIndex = prev.findIndex(
        (item) => item.material_no === material_no,
      );

      const resultItem = {
        material_no,
        ohqty: ohqty,
        bin_location,
        b_un,
        abc_class,
        material_desc,
        updated_qty: "", // Initialize with empty string
        isUpdated: true,
      };

      if (existingIndex !== -1) {
        const updatedResults = [...prev];
        updatedResults[existingIndex] = resultItem;
        return updatedResults;
      } else {
        return [...prev, resultItem];
      }
    });

    // Focus the input after state updates
    setTimeout(() => {
      if (inputRefs.current[material_no]) {
        inputRefs.current[material_no].focus();
      }
    }, 0);
  };

  const handleNokValueChange = (
    material_no,
    newValue,
    currentOhqty,
    bin_location,
    material_desc,
    b_un,
    abc_class,
  ) => {
    console.log("in no ok change");
    const parsedNewValue = newValue;
    if (parsedNewValue === "" || parsedNewValue === undefined) {
  setInventoryStatus((prev) => {
    const updated = { ...prev };
    delete updated[material_no];
    return updated;
  });

  setNokResults((prev) =>
    prev.filter((item) => item.material_no !== material_no),
  );

  return;
}
    const parsedCurrentOhqty = parseInt(currentOhqty);
    const isValid = parsedNewValue !== parsedCurrentOhqty;
    console.log("checcking valid ", isValid);
    console.log("Parced New value", parsedNewValue);
    console.log("Current", parsedCurrentOhqty);

    setInventoryStatus((prev) => ({
      ...prev,
      [material_no]: {
        ...prev[material_no],
        ohqty: parsedCurrentOhqty,
        updatedOhq: parsedNewValue,
        validationPassed: isValid,
      },
    }));

    if (isValid) {
      setNokResults((prev) => {
        const existingIndex = prev.findIndex(
          (item) => item.material_no === material_no,
        );

        const resultItem = {
          material_no,
          ohqty: parsedCurrentOhqty,
          bin_location,
          material_desc,
          updated_qty: parsedNewValue,
          isUpdated: true,
          b_un,
          abc_class,
        };

        if (existingIndex !== -1) {
          const updatedResults = [...prev];
          updatedResults[existingIndex] = resultItem;
          return updatedResults;
        } else {
          return [...prev, resultItem];
        }
      });
    } else {
      // Remove from nokResults when value matches ohqty

      setNokResults((prev) =>
        prev.filter((item) => item.material_no !== material_no),
      );
    }
  };

  const handleCloseClick = (material_no) => {
    setInventoryStatus((prev) => ({
      ...prev,
      [material_no]: {
        okClicked: false,
        nokClicked: false,
        validationPassed: false,
        updatedOhq: null,
      },
    }));

    setOkResults((prev) =>
      prev.filter((item) => item.material_no !== material_no),
    );
    setNokResults((prev) =>
      prev.filter((item) => item.material_no !== material_no),
    );
  };

  useEffect(() => {
    if (okResults?.length + nokResults?.length > 0) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }, [wareHouseAllMaterialData?.length, okResults?.length, nokResults?.length]);

  useEffect(() => {
    setAssetData([
      [{ name: t("plant"), value: terminal_id }],
      [{ name: t("str_loc"), value: storage_loc }],
      [{ name: t("str_bin_grp"), value: storage_bin }],
    ]);
    setInfoRowData([
      { value: `name`, type: "T" },
      { value: `value`, type: "T" },
    ]);
  }, [terminal_id, storage_loc, storage_bin, i18n.language]);

  useEffect(() => {
    const clearBackKey = () => {
      localStorage.removeItem("back");
    };

    window.addEventListener("beforeunload", clearBackKey);
    window.addEventListener("unload", clearBackKey);
    window.addEventListener("pagehide", clearBackKey);

    return () => {
      window.removeEventListener("beforeunload", clearBackKey);
      window.removeEventListener("unload", clearBackKey);
      window.removeEventListener("pagehide", clearBackKey);
    };
  }, []);

  const gsOneToolRedirectMethod = (material_no) => {
    localStorage.removeItem("back");
    window.open(
      `/warehouse/spare-part-info?material_no=${material_no}`,
      "_blank",
    );
  };

  const handleGoBack = () => {
    navigate(
      `/warehouse/whs-location-info?terminal_id=${terminal_id}&storage_bin=${storage_bin}&storage_loc=${storage_loc}`,
    );
  };
  const [selectedClass, setSelectedClass] = useState("All classes");
  const [selectedCriticality, setSelectedCriticality] =
    useState("All indicators");
  const [abcInfoOpen, setAbcInfoOpen] = useState(false);
  const handleAbcInfoOpen = () => {
    setAbcInfoOpen(true);
  };

  const handleAbcInfoClose = () => {
    setAbcInfoOpen(false);
  };
  // Update the filtering function
  const getFilteredMaterialData = () => {
    if (!wareHouseAllMaterialData) return [];

    let filteredData = wareHouseAllMaterialData;

    // Filter by ABC class
    if (selectedClass !== "All classes") {
      filteredData = filteredData.filter(
        (item) => {
          return(
          selectedClass==="A&B"?(item.abc_class === "A" || item.abc_class === "B"):item.abc_class === selectedClass)
        }
      );
    }

    // Filter by Material Criticality
    if (selectedCriticality !== "All indicators") {
      filteredData = filteredData.filter(
        (item) => item.mat_indicator === selectedCriticality,
      );
    }

    return filteredData;
  };

  // Add callback for criticality filter
  const handleClassFilterChange = (classValue) => {
    setSelectedClass(classValue);
  };

  const handleCriticalityFilterChange = (criticalityValue) => {
    setSelectedCriticality(criticalityValue);
  };

  return (
    <Grid
      item
      xs={10}
      sm={10}
      md={10}
      lg={10}
      xl={10}
      sx={{ margin: "1em 0.5em 0.5em 0.5em" }}
    >
      {popUpBox ? <CAuthPopUpBox CText={t("unauth")} /> : null}
      {confirmationBox ? (
        <CountingConfirmation
          CText={t("email_send")}
          TotalOK={okResults.length}
          TotalNOK={nokResults.length}
          terminal_id={terminal_id}
          storage_bin={storage_bin}
          storage_loc={storage_loc}
        />
      ) : null}
      {isConfirmation ? (
        <EmailConfirmation
          CText={t("email_confirm")}
          handleClose={confirmationBoxClose}
          handleSubmit={handleCount}
          isDisabled={isDisabled}
        />
      ) : null}
      <CBackDrop cOpen={loading || sendLoading} />

      <Card sx={{ padding: "0.5em" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "1em",
          }}
        >
          <Box>
            <Button
              color="primary"
              variant="contained"
              size="small"
              startIcon={
                <KeyboardArrowLeftIcon sx={{ color: "#fff", fontSize: 14 }} />
              }
              onClick={handleGoBack}
              sx={{
                color: "#fff",
                fontSize: ".8rem",
                gap: "0px",
                minWidth: "auto",
                padding: "6px 10px",
              }}
            >
              {t("go_back")}
            </Button>
          </Box>
          <Tooltip title={t("tool_counting_msg")}>
            <IconButton
              id="mail"
              style={{
                backgroundColor: "#052660",
                color: "#FFFFFF",
                borderRadius: 5,
                padding: "8px",
                cursor: "pointer",
              }}
              onClick={confirmationBoxOpen}
            >
              <MailIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </div>
        <CAccordion
          CHeader={t("general_info")}
          CData={assetData}
          CRows={infoRowData}
          COpen={false}
          onClassChange={handleClassFilterChange}
          onCriticalityChange={handleCriticalityFilterChange}
        />

        <OrderBoxText>{t("inventory_details")}</OrderBoxText>
        <Box
          sx={{
            border: "1px solid #3CB043",
            borderRadius: "0 0 1em 1em",
            overflowX: "auto",
            whiteSpace: "nowrap",
            marginBottom: "3em",
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": { display: "none" },
          }}
        >
          <Table sx={{ overflowX: "auto" }}>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    padding: "6px 8px",
                    fontSize: commonFontSize,
                    width: "180px",
                  }}
                >
                  {t("str_bin")}
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    padding: "6px 8px",
                    fontSize: commonFontSize,
                    width: "180px",
                  }}
                >
                  {t("bulk_loc")}
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    padding: "6px 12px",
                    fontSize: commonFontSize,
                    width: "180px",
                    overflowX: "auto",
                    whiteSpace: "nowrap",
                  }}
                >
                  {t("material_number")}
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    padding: "6px 6px 6px 20px", // Remove horizontal padding
                    fontSize: commonFontSize,
                    width: "85px",
                    maxWidth: "85px",
                    whiteSpace: "nowrap",
                  }}
                >
                  {t("Batch")}
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    padding: "6px 0 6px 20px", // Remove horizontal padding
                    fontSize: commonFontSize,
                    width: "60px",
                    maxWidth: "60px",
                    whiteSpace: "nowrap",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "2px",
                      justifyContent: "center",
                    }}
                  >
                    <span>
                      ABC {t("Class")}
                      <br />
                      / {t('Criticality')}
                    </span>
                    <IconButton
                      size="small"
                      onClick={handleAbcInfoOpen}
                      onMouseEnter={handleAbcInfoOpen}
                      sx={{
                        padding: "0px",
                        color: "#052660",
                      }}
                    >
                      <InfoIcon fontSize="small" />
                    </IconButton>
                  </Box>
                </TableCell>
                {/* ABC Class Info Dialog */}
                <Dialog
                  open={abcInfoOpen}
                  onClose={handleAbcInfoClose}
                  maxWidth="sm"
                  fullWidth
                  PaperProps={{
                    onMouseLeave: handleAbcInfoClose, // Add this to close when mouse leaves
                    sx: {
                      pointerEvents: "auto",
                    },
                  }}
                  BackdropProps={{
                    invisible: true, // Make backdrop invisible for better hover experience
                  }}
                >
                  <DialogTitle
                    sx={{
                      backgroundColor: "#3CB043",
                      color: "white",
                      fontWeight: "bold",
                    }}
                  >
                    {t("ABC Classification Information")}
                  </DialogTitle>
                  <DialogContent sx={{ mt: 2 }}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell
                            sx={{
                              fontWeight: "bold",
                              fontSize: "1em",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {t("Classification")}
                          </TableCell>
                          <TableCell
                            sx={{
                              fontWeight: "bold",
                              fontSize: "1em",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {t("Counting Frequency")}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell
                            sx={{
                              backgroundColor: "#fff3e0",
                              fontWeight: "600",
                            }}
                          >
                            {t("Class")} A {t("Items")}
                          </TableCell>
                          <TableCell>{t("Once every six months")}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              backgroundColor: "#e3f2fd",
                              fontWeight: "600",
                            }}
                          >
                            {t("Class")} B {t("Items")}
                          </TableCell>
                          <TableCell>{t("Once a year")}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              backgroundColor: "#f1f8e9",
                              fontWeight: "600",
                            }}
                          >
                            {t("Class")} C {t("Items")}
                          </TableCell>
                          <TableCell>{t("Once a year")}</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </DialogContent>
                  <DialogActions sx={{ p: 2 }}>
                    <Button
                      onClick={handleAbcInfoClose}
                      variant="contained"
                      color="primary"
                    >
                      {t("close")}
                    </Button>
                  </DialogActions>
                </Dialog>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    padding: "6px 1px",
                    fontSize: commonFontSize,
                    textAlign: "center",
                    margin: "0 1em",
                  }}
                >
                  {t("ohq")}
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    padding: "6px 12px",
                    width: "80px",
                    fontSize: commonFontSize,
                  }}
                >
                  {t("UOM")}
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    padding: "6px 12px",
                    fontSize: commonFontSize,
                  }}
                >
                  {t("material_description")}
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    padding: "6px 12px",
                    fontSize: commonFontSize,
                  }}
                >
                  {t("Last counted at")}
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    padding: "6px 12px",
                    fontSize: commonFontSize,
                  }}
                >
                  {t("Last counted by")}
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    padding: "6px 12px",
                    fontSize: commonFontSize,
                  }}
                >
                  {t("Last counted status")}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {getFilteredMaterialData()?.map((row, rowIndex) => {
                const status = inventoryStatus[row.material_no] || {};
                return (
                  <TableRow key={rowIndex}>
                    <TableCell
                      sx={{
                        padding: "8px",
                        fontSize: commonFontSize,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {row.bin_location}
                    </TableCell>
                    <TableCell
                      sx={{
                        padding: "8px",
                        fontSize: commonFontSize,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {row.bulk_location ?? "---"}
                    </TableCell>
                    <TableCell
                      sx={{
                        padding: "8px 12px",
                        fontSize: commonFontSize,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      <Tooltip title={t("resolver_tool")}>
                        <button
                          onClick={() =>
                            gsOneToolRedirectMethod(row.material_no)
                          }
                          style={{
                            background: "none",
                            border: "none",
                            color: "blue",
                            textDecoration: "underline",
                            cursor: "pointer",
                            padding: "0",
                            fontSize: "inherit",
                            fontFamily: "inherit",
                          }}
                        >
                          {row.material_no}
                        </button>
                      </Tooltip>
                    </TableCell>
                    <TableCell
                      sx={{
                        padding: "8px 0px",
                        fontSize: commonFontSize,
                        width: "85px",
                        maxWidth: "85px",
                        whiteSpace: "nowrap",
                        textAlign: "center",
                      }}
                    >
                      <span>
                        {row.batch_found}
                      </span>
                    </TableCell>
                    <TableCell
                      sx={{
                        padding: "8px 0px",
                        fontSize: commonFontSize,
                        width: "85px",
                        maxWidth: "85px",
                        whiteSpace: "nowrap",
                        textAlign: "center",
                      }}
                    >
                      <span>
                        {row.abc_class} / {row.mat_indicator}
                      </span>
                    </TableCell>
                    <TableCell
                      sx={{
                        padding: "8px 1px",
                        fontSize: commonFontSize,
                        position: "relative",
                        minWidth: "180px", // Increased to accommodate buttons
                        width: "180px",
                      }}
                    >
                      {row.user_role === "Warehouse User" ?
                        <>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "8px",
                              flexWrap: "nowrap",
                              width: "100%"
                            }}
                          >
                            <input
                              ref={(el) => (inputRefs.current[row.material_no] = el)}
                              type="number"
                              inputMode="numeric"
                              pattern="[0-9]*"
                              min="0"
                              step="1"
                              // value={
                              //   nokResults.find(
                              //     (r) => r.material_no === row.material_no,
                              //   )?.updated_qty || ""
                              // }
                              value={currentValue[rowIndex]}
                              style={{
                                width: "55px",
                                height: "30px",
                                padding: "0",
                                borderRadius: "4px",
                                //backgroundColor: "red",
                                border: "1px solid black",
                                color: "white",
                                textAlign: "center",
                                fontSize: ".9em",
                                outline: "none",
                                transition: "background-color 0.2s ease",
                              }}
                              onFocus={(e) => {
                                e.target.style.backgroundColor = "white";
                                e.target.style.border = "1px solid black";
                                e.target.style.color = "black";
                              }}
                              onBlur={(e) => {
                                console.log("We are in on blur");
                                console.log(e.target.value);

                                const currentValue = nokResults.find(
                                  (r) => r.material_no === row.material_no,
                                )?.updated_qty;

                                console.log("the updated value is ");
                                console.log(currentValue);
                                // if(currentValue !== "" &&
                                //   currentValue !== undefined ){
                                //   e.target.style.backgroundColor = "green";
                                // e.target.style.border = "none";
                                // e.target.style.color = "white";
                                // }
                                if (
                                  currentValue !== "" &&
                                  currentValue !== undefined &&
                                  Number(currentValue) === Number(row.ohqty)
                                ) {
                                  handleOkClick(
                                    row.material_no,
                                    row.ohqty,
                                    row.bin_location,
                                    row.material_desc,
                                    row.b_un,
                                    row.abc_class,
                                  );
                                }
                              }}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();

                                  const userValue = nokResults.find(
                                    (r) => r.material_no === row.material_no,
                                  )?.updated_qty;

                                  if (
                                    userValue === "" ||
                                    userValue === undefined
                                  ) {
                                    return;
                                  }

                                  e.target.blur();
                                }
                              }}
                              onChange={(e) => {
                                let sanitizedValue = e.target.value.replace(
                                  /[^\d]/g,
                                  "",
                                );

                                if (sanitizedValue === "") {
                                  e.target.value = "";
                                } else {
                                  e.target.value =
                                    sanitizedValue.replace(/^0+/, "") || "0";
                                }

                                setCurrentValue((prev) => ({
                                  ...prev,
                                  rowIndex: e.target.value,
                                }))

                                if (e.target.value === "" || e.target.value === undefined) {
                                  setCurrentValue((prev) => {
                                    const updated = { ...prev };
                                    delete updated[rowIndex];
                                    return updated;
                                  });
                                }

                                console.log("going in nookvalue change", e.target.value);
                                //if(e.target.value!=="" && e.target.value!=undefined){
                                handleNokValueChange(
                                  row.material_no,
                                  e.target.value,
                                  row.ohqty,
                                  row.bin_location,
                                  row.material_desc,
                                  row.b_un,
                                  row.abc_class,
                                );}
                              }//}
                            />
                          </div>
                        </>
                        :
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "8px",
                            flexWrap: "nowrap",
                          }}
                        >
                          {/* OK BUTTON SLOT */}
                          <div style={{ minWidth: "55px" }}>
                            <button
                              onClick={() =>
                                handleOkClick(
                                  row.material_no,
                                  row.ohqty,
                                  row.bin_location,
                                  row.material_desc,
                                  row.b_un,
                                  row.abc_class,
                                )
                              }
                              style={{
                                backgroundColor: "#3CB043",
                                color: "white",
                                border: "none",
                                padding: "8px",
                                borderRadius: "4px",
                                cursor: "pointer",
                                fontSize: "0.8em",
                                width: "100%",
                                visibility:
                                  status.okClicked || status.nokClicked
                                    ? "hidden"
                                    : "visible",
                              }}
                            >
                              OK
                            </button>
                          </div>

                          {/* OHQ */}
                          <span
                            style={{
                              minWidth: "30px",
                              textAlign: "center",
                              fontWeight: "500",
                            }}
                          >
                            {row.ohqty}
                          </span>

                          {/* NOK SLOT */}
                          <div
                            style={{
                              minWidth: "55px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "8px",
                            }}
                          >
                            {/* NOK BUTTON */}
                            {!status.nokClicked && (
                              <button
                                onClick={() => {
                                  // show input first, do not decide yet
                                  handleNokClick(
                                    row.material_no,
                                    row.ohqty,
                                    row.bin_location,
                                    row.b_un,
                                    row.material_desc,
                                    row.abc_class,
                                  );
                                }}
                                style={{
                                  backgroundColor: "red",
                                  color: "white",
                                  border: "none",
                                  padding: "8px",
                                  borderRadius: "4px",
                                  cursor: "pointer",
                                  fontSize: "0.8em",
                                  width: "100%",
                                  visibility: status.okClicked
                                    ? "hidden"
                                    : "visible",
                                }}
                              >
                                NOK
                              </button>
                            )}

                            {/* INPUT */}
                            {status.nokClicked && (
                              <>
                                <StyledInput
                                  ref={(el) =>
                                    (inputRefs.current[row.material_no] = el)
                                  }
                                  type="number"
                                  inputMode="numeric"
                                  pattern="[0-9]*"
                                  min="0"
                                  step="1"
                                  c_ohq={row.ohqty}
                                  value={
                                    nokResults.find(
                                      (r) => r.material_no === row.material_no,
                                    )?.updated_qty || ""
                                  }
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      e.preventDefault();

                                      const userValue = nokResults.find(
                                        (r) => r.material_no === row.material_no,
                                      )?.updated_qty;

                                      if (
                                        userValue === "" ||
                                        userValue === undefined
                                      ) {
                                        return;
                                      }

                                      e.target.blur();
                                    }
                                  }}
                                  onChange={(e) => {
                                    let sanitizedValue = e.target.value.replace(
                                      /[^\d]/g,
                                      "",
                                    );

                                    if (sanitizedValue === "") {
                                      e.target.value = "";
                                    } else {
                                      e.target.value =
                                        sanitizedValue.replace(/^0+/, "") || "0";
                                    }

                                    handleNokValueChange(
                                      row.material_no,
                                      e.target.value,
                                      row.ohqty,
                                      row.bin_location,
                                      row.material_desc,
                                      row.b_un,
                                      row.abc_class,
                                    );
                                  }}
                                  onBlur={(e) => {
                                    const currentValue = nokResults.find(
                                      (r) => r.material_no === row.material_no,
                                    )?.updated_qty;

                                    if (
                                      currentValue !== "" &&
                                      currentValue !== undefined &&
                                      Number(currentValue) === Number(row.ohqty)
                                    ) {
                                      handleOkClick(
                                        row.material_no,
                                        row.ohqty,
                                        row.bin_location,
                                        row.material_desc,
                                        row.b_un,
                                        row.abc_class,
                                      );
                                    }
                                  }}
                                  onPaste={(e) => {
                                    e.preventDefault();
                                    const pastedText =
                                      e.clipboardData.getData("text");

                                    if (/^\d+$/.test(pastedText)) {
                                      const sanitizedValue =
                                        pastedText.replace(/^0+/, "") || "";
                                      e.target.value = sanitizedValue;

                                      handleNokValueChange(
                                        row.material_no,
                                        sanitizedValue,
                                        row.ohqty,
                                        row.bin_location,
                                        row.material_desc,
                                        row.b_un,
                                        row.abc_class,
                                      );
                                    }
                                  }}
                                />

                                {!status.validationPassed && (
                                  <CloseIcon
                                    sx={{
                                      color: "red",
                                      cursor: "pointer",
                                      fontSize: "1.2em",
                                    }}
                                    onClick={() =>
                                      handleCloseClick(row.material_no)
                                    }
                                  />
                                )}
                              </>
                            )}
                          </div>
                        </div>}
                    </TableCell>
                    <TableCell
                      sx={{
                        padding: "8px",
                        fontSize: commonFontSize,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {row.b_un}
                    </TableCell>
                    <TableCell
                      sx={{
                        padding: "8px 12px",
                        fontSize: commonFontSize,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {row.material_desc}
                    </TableCell>
                    <TableCell
                      sx={{
                        padding: "8px 12px",
                        fontSize: commonFontSize,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {row.last_counted_date ? new Date(row.last_counted_date * 1000).toLocaleString() : ""}
                    </TableCell>
                    <TableCell
                      sx={{
                        padding: "8px 12px",
                        fontSize: commonFontSize,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {row.last_counted_name}
                    </TableCell>
                    <TableCell
                      sx={{
                        padding: "8px 12px",
                        fontSize: commonFontSize,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {row.summary}
                    </TableCell>
                  </TableRow>
                );
              })}
              {getFilteredMaterialData()?.length === 0 && (
                <TableRow>
                  <TableCell colSpan={4} sx={{ textAlign: "center" }}>
                    {t("no_data")}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Box>
      </Card>
    </Grid>
  );
};

export default WareHouseCounting;
